import { createButton } from './common/ui'
import {lang} from './library/lang';

export default class UiHelp extends PIXI.Container
{
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;

        const config = configGame.Help;
        this.config = config;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");

        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "background_utility.png"]);
        this.background.position = config.background.pos;
        this.background.interactive = true;     // block interactive of overlaid buttons
        this.addChild(this.background);

        this.backgroundTitle = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "title_help.png"]);
        this.backgroundTitle.position = config.backgroundTitle.pos;
        this.background.addChild(this.backgroundTitle);

        this.buttonOk = createButton(this.background, config.buttonOk.pos.x, config.buttonOk.pos.y, packFolder + "ok_info", this.sndBtnClick);

        this.labelTitle = new PIXI.Text('', config.labelTitle.font);
        this.labelTitle.position.set(config.labelTitle.pos.x, config.labelTitle.pos.y);
        this.labelTitle.anchor.set(0.0, 0.0);
        this.background.addChild(this.labelTitle);

        this.labelInfo = new PIXI.Text('', config.labelInfo.font);
        this.labelInfo.position.set(config.labelInfo.pos.x, config.labelInfo.pos.y);
        this.labelInfo.anchor.set(0.0, 0.0);
        this.background.addChild(this.labelInfo);

        this.lastBetMin = '0';
        this.lastBetMax = '0';

        this.updateInfo('1', '1');
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.layerBlockInput = null;

        this.background = null;
        this.backgroundTitle = null;
        this.labelTitle = null;
        this.labelInfo = null;

        this.buttonOk = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
    }

    updateInfo (betMinStr, betMaxStr) {
        if(betMinStr === this.lastBetMin && betMaxStr === this.lastBetMax) return;

        this.lastBetMin = betMinStr;
        this.lastBetMax = betMaxStr;

        const translateList = this.config.translateList;
        const lng = lang();

        this.labelTitle.text = translateList.name[lng];

        let replaceMark = { "#01": betMinStr, "#02": betMaxStr };
        this.labelInfo.text = translateList.info[lng].replace(/#01|#02/g, function(match) {return replaceMark[match];});
    }

    setOnButtonCloseEvent (func) {
        this.buttonOk.callback = function() {func();};
    }
}


// WEBPACK FOOTER //
// ./src/uihelp.es6